// PublicDocument.ts
import { postJson } from '../ChoiceApi';
import { IDocumentSaveInputs } from './DocumentManager';

export async function Save(payload: IDocumentSaveInputs) {
    return postJson("api/public/Documents/SaveDocument", payload);
}